import { FormattedMessage } from 'react-intl'
import { Grid } from '@mui/material'
import { Button } from '@carto/meridian-ds/components'

import NoMapIcon from 'assets/icons/carto-icon-maps-no-map.svg?react'

import EmptyState from 'features/common/ui/utils/EmptyState'
import useUserRoles from 'features/account/state/useUserRoles'
import { openNewWindow } from 'features/common/utils/navigationUtils'
import { BuilderPaths } from 'features/builder/paths'

function MapsEmpty() {
  const { userHasEditionRole, userIsGuest } = useUserRoles()

  const addMap = () => {
    openNewWindow(BuilderPaths.NewEmptyMap)
  }

  const CreateAMap = () => (
    <EmptyState icon={NoMapIcon} caption={<FormattedMessage id="maps.emptyState.caption" />}>
      <Button color="primary" variant="contained" size="large" onClick={addMap}>
        <FormattedMessage id="maps.emptyState.button" />
      </Button>
    </EmptyState>
  )

  const CanNotCreateAMap = () => (
    <EmptyState icon={NoMapIcon} caption={<FormattedMessage id="maps.emptyState.canNotCreate" />}></EmptyState>
  )

  const NoMapsBeenShared = () => (
    <EmptyState icon={NoMapIcon} caption={<FormattedMessage id="maps.emptyState.noMapsBeenShared" />}></EmptyState>
  )

  return (
    <Grid container direction="column" alignItems="center" mb={6}>
      {userHasEditionRole ? <CreateAMap /> : userIsGuest ? <NoMapsBeenShared /> : <CanNotCreateAMap />}
    </Grid>
  )
}

export default MapsEmpty
